import React from "react";
import { StickerCard } from "@/components/StickerCard";
import { Sparkles } from "lucide-react";

export function StickerGrid({ stickers, favIds, onToggleFav, emptyText = "Nenhum sticker por aqui ainda." }) {
  if (!stickers || stickers.length === 0) {
    return (
      <div className="py-16 text-center text-[#7A7571]" data-testid="empty-stickers">
        <Sparkles className="mx-auto mb-3 text-[#E8CFD1]" size={36} />
        <p>{emptyText}</p>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-5">
      {stickers.map((s, i) => (
        <StickerCard
          key={s.id}
          sticker={s}
          index={i}
          isFav={favIds?.has(s.id)}
          onToggleFav={onToggleFav}
        />
      ))}
    </div>
  );
}
